export class UrlUtils {
  /**
   * Converts the given object into url query parameters and returns them into a string.
   * @param params A key value object.
   */
  public static generateUrlParameters(params: { [key: string]: string }): string {
    const lambda = Object.keys(params).length
      ? Object.keys(params)
        .reduce((stringDataArray, key) => {
          const value = params[key];

          return [
            ...stringDataArray,
            `${key}=${value}`,
          ];
        }, [])
        .join('&')
      : null;

    return lambda;
  }

  /**
   * Extracts the parameters from the given URL while returning a key value object.
   * @param url The full url.
   */
  public static extractUrlParamsFromExistingUrl(url: string): { [key: string]: string } {
    const urlParamIndex = url.indexOf('?');

    if (urlParamIndex !== -1) {
      const lambda = url.substring(urlParamIndex + 1)
        .split('&')
        .reduce((previousValue, currentValue) => {
          const keyValue = currentValue.split('=');
          return {
            ...previousValue,
            [keyValue[0]]: keyValue[1],
          };
        }, {});

      return lambda;
    }

    return {};
  }

  /**
   * Removes the query parameters from the URL.
   * @param url The full url.
   */
  public static removeQueryParameters(url: string): string {
    const index = url.indexOf('?');
    return index === -1
      ? url
      : url.substr(0, index);
  }

  public static isExternal(url: string): boolean {

    const pat = /^https?:\/\//i;

    if (pat.test(url)) {
      //check if it matches the current url origin
      return new URL(url).origin !== window.location.origin;
    }

    return false;
  }

  public static generateClassNameFromDomainName(url: string): string {
    if (url) {
      const domainExtractRegex = /^(?:https?:\/\/)?(?:www\.)?([^.]+)/i;
      const regexMatchData = url.match(domainExtractRegex);

      return regexMatchData[regexMatchData.length - 1]; // Get last capture group
    }

    return '';
  }

  /**
   * URL encode the parameters and then apply base64 encode.
   * @param value The value to encode.
   */
  public static encodeUrlParams(value: string): string {
    return btoa(encodeURIComponent(value));
  }

  /**
   * Base64 decode the parameters, URL decode and then split by Pipeline.
   * @param value The value to decode.
   */
  public static decodeUrlParams(value: string): string[] {
    return decodeURIComponent(atob(value))
      .split('|');
  }

  public static slugify(text: string, spaceReplacement: string = '-'): string {
    const lambda = text
      .toString()                      // Cast to string
      .toLowerCase()                   // Convert the string to lowercase letters
      .normalize('NFD')          // To normalize() method returns the Unicode Normalization Form of a given string.
      .trim()                         // Remove whitespace from both sides of a string
      .replace(/\s+/g, spaceReplacement)           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')        // Remove all non-word chars
      .replace(/\-\-+/g, spaceReplacement);        // Replace multiple - with single -
    return lambda;
  }

  public static serialize(obj, prefix?) {
    const str = [];
    let p;
    for (p in obj) {
      if (obj.hasOwnProperty(p)) {
        const k = prefix ? prefix + '[' + p + ']': p;
        const v = obj[p];
        str.push((v !== null && typeof v === 'object') ?
          this.serialize(v, k):
          encodeURIComponent(k) + '=' + encodeURIComponent(v));
      }
    }
    return str.join('&');
  }
}
